import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useErrorStore = defineStore('error', () => {
  const status_code = ref(200)
  const detail = ref('')
  const endpoint = ref('')

  const setStatusCode = (status: number, message: string) => {
    status_code.value = status
    detail.value = message
  }

  return { status_code, detail, endpoint, setStatusCode }
});
